import { memo } from 'react'
import { createPortal } from 'react-dom'

import { Container, Overlay, Inner } from './Styles'
import { overlayVariants, contentVariants } from './Animations'

const Modal = ({ visible, children, columnWidth = '48% 52%' }) => {
  // Render into document.body via a portal. The Actions modal is a
  // position: fixed overlay, but its ancestor tab wrapper (Tabs/index.js) is a
  // framer-motion element with a lingering `transform`, which creates a
  // stacking context and traps the modal's z-index below the patient details
  // header. Portalling to body lets the fixed overlay escape that context and
  // sit above the header as intended.
  return createPortal(
    <Container clickable={visible} columnWidth={columnWidth}>
      <Overlay
        initial="initial"
        animate={visible ? 'visible' : 'initial'}
        variants={overlayVariants}
      />
      <Inner initial="initial" animate={visible ? 'visible' : 'initial'} variants={contentVariants}>
        {children}
      </Inner>
    </Container>,
    document.body
  )
}

Modal.whyDidYouRender = true

export default memo(Modal)
